export const NO_ACTION_PERMISSION: string =
  "You do not have permissions to perform this action.";

export const NO_RESOURCE_PERMISSION: string =
  "You do not have permission to access this resource.";
